import { render, staticRenderFns } from "./table-cmp.vue?vue&type=template&id=19f470fc&scoped=true"
import script from "./table-cmp.vue?vue&type=script&lang=js"
export * from "./table-cmp.vue?vue&type=script&lang=js"
import style0 from "./table-cmp.vue?vue&type=style&index=0&id=19f470fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f470fc",
  null
  
)

export default component.exports